class layLoadingDirective {
	constructor() {
		this.restrict = "EA";
		this.scope = {
			lazyLoading: "@"
		};
	}

	link(scope, element) {

		let requestStoped = true,
			scrollEl = element[0].getAttribute("data-scrollable") || null,
			parentController = scope.$parent[scope.lazyLoading];

		let scrollEvent = (e) => {

			if (!parentController.loading) {
				requestStoped = true;
			}

			let target = e.target,
				scrollHeight = target.scrollHeight,
				scrollTop = target.scrollTop,
				offsetHeight = target.offsetHeight,
				currentPosition = ( scrollTop + offsetHeight ),
				callbackPosition = scrollHeight - ( scrollHeight * 0.10 );

			if (typeof parentController.getNextUri  === "function") {
				if (!parentController.getNextUri()) {
					return false;
				}
			} else if (!parentController.tableConfiguration.next_uri) {
				return false;
			}

			if (currentPosition > callbackPosition && requestStoped) {
				parentController.$onInit(true);
				requestStoped = false;
			}

		};

		angular.element(scrollEl ? document.querySelector(scrollEl) : document.getElementsByTagName("main")).bind("scroll", scrollEvent);

	}

	static create() {
		return new layLoadingDirective(...arguments);
	}
}

layLoadingDirective.create.$inject = [];

export {layLoadingDirective};


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/lazyloading.directive.js
 **/